module.exports = __webpack_public_path__ + "img/ge-flag.96b28023.png";